module.exports = __webpack_public_path__ + "img/b_logo_2.da68c25b.png";